import {getBounds} from '@packages/shared/utilities/DomUtils';
import {getOutlinePositionMode} from '@packages/systems/designer/ui';
import {
  getDesignerAppOrigin,
  getAnonymousCommentsAppOrigin,
} from '@packages/utilities/canvas-origin';
import {getMeasurableNativeNodeByNativeIdPath} from '../../utils';

/**
 * Handles case when through postMessage function execution inside the Canvas App is requested from the Designer App
 */
export const handleFunctionExecutionRequested = (
  eventData: {
    type: 'function';
    functionId: string;
    functionName: string;
    functionArgs: any;
  },
  origin: string
) => {
  if (eventData.type !== 'function') {
    return;
  }

  if (eventData.functionName === 'getNodeBoundsAndPosition') {
    const nodeIdPath = eventData.functionArgs?.nativeIdPath;
    const functionId = eventData.functionId;
    const nativeNode = getMeasurableNativeNodeByNativeIdPath(nodeIdPath);

    // Reply even when the node is missing so the Designer-side promise settles
    // instead of hanging forever and leaking a pendingFunctionCalls entry.
    const bounds = nativeNode ? getBounds(nativeNode) : null;
    const positionMode = nativeNode ? getOutlinePositionMode(nativeNode) : null;

    const message = {
      type: 'function',
      functionResult: {bounds, positionMode},
      functionId,
    };
    const designerAppOrigin = getDesignerAppOrigin(window.location.origin);
    const anonymousCommentsAppOrigin = getAnonymousCommentsAppOrigin(
      window.location.origin
    );

    if (designerAppOrigin && origin === designerAppOrigin) {
      window.parent.postMessage(message, designerAppOrigin);
      return;
    }

    if (anonymousCommentsAppOrigin && origin === anonymousCommentsAppOrigin) {
      window.parent.postMessage(message, anonymousCommentsAppOrigin);
      return;
    }
  }

  if (process.env.NODE_ENV === 'development') {
    console.error('Function is not supported in the Canvas App.');
  }
};
